import * as axios from "axios";

let qs = require('qs');
const instance = axios.create({
    withCredentials:true,
    baseURL: 'https://apicalc.intersog.com/',
});

export const getApiCountries = () => {
    return instance.get(`location/?action=get_countries`)
        .then(response => {
            return response.data;
        });
};

export const getProfessions = (sid) => {
    return instance.get(`staff/?sid=${sid}&action=staff`)
        .then(response => {
            return response.data;
        });
};

export const getStaffList = () => {
    return instance.get(`staff/?action=staff_list`)
        .then(response => {
            return response.data;
        });
};

export const getRequest = (method, property) => {
    return instance.get(`requests/?method=${method}&property=${property}`)
        .then(response => {
            return response.data;
        });
};

export const sendData = (compiled) => {
    return instance.post(`staff/?action=calculate`, qs.stringify(compiled))
        .then(response => {
            return response.data;
        });
};

export const getUserLocation = () => {
    return axios.get('https://intersog.com/api/geolocation/').then(
        response => {
            return response.data;
        }
    );
};